module.exports = __webpack_public_path__ + "assets/img/6.00146664.jpg";